import React, { useState } from 'react';
import parse from "html-react-parser";
import styled from 'styled-components';
import {
    Modal, ModalHeader, ModalBody, ModalFooter, Label, Button
} from '@americanexpress/dls-react';

function EligibilityCriteria({ eligibilityCriteria, cityList }) {
    const [show, setShow] = useState(false);
    const showModal = (e) => { e.preventDefault(); setShow(true); }
    const closeModal = () => setShow(false);

    const eligibleResidentCities = [];
    eligibleResidentCities.push(
        ...cityList.map((city) => (
            <li className="margin-1-b pull-left-md-up pad-0-l-md-up pad-4-l-xs-up" key={city}>
                <span>{city}</span>
            </li>
        ))
    );
    return (
        <div>
            <a className="text-underline" onClick={showModal} href="/#">Important: Please Read the Eligibility Criteria Before Starting your Application</a>
            {show && (
                <div>
                    <Modal
                        onClose={closeModal}
                        theme={{
                            // allows the modal to be scrollable but scrollbar not to be shown
                            '& > div': {
                                maxWidth: '64.5rem',
                                overflowY: 'auto',
                                msOverflowStyle: 'none',
                                scrollbarWidth: 'none',
                                '::-webkit-scrollbar': { display: 'none' },
                            },
                        }}
                    >
                        <ModalHeader>
                            <h2 className="fluid heading-3"> Eligibility Criteria</h2>
                        </ModalHeader>
                        <ModalBody>
                            <div className="row">
                                <div className="col-xl-offset-1 col-lg-11 pad-2 stack">
                                    <ul className="stack">
                                        {eligibilityCriteria.map(criteria => (
                                            <li key={criteria}>{parse(criteria)}</li>
                                        ))}
                                    </ul>
                                </div>
                                <div className="col-xl-offset-1 col-lg-11 pad-2 stack">
                                    <Label className="label-2 text-capitalize">We currently operate in these cities:</Label>
                                    <ResidentCities className="checklist stack-1 stack-r">
                                        {eligibleResidentCities}
                                    </ResidentCities>
                                </div>
                            </div>
                        </ModalBody>
                        <ModalFooter>
                            <Button styleType="primary" onClick={closeModal}>
                                Continue
                            </Button>
                        </ModalFooter>
                    </Modal></div>
            )}
        </div>

    );
}

const ResidentCities = styled.ul`
@media(max-width: 420px) {
  -webkit-column-count: 1;
    -moz-column-count: 1;
    column-count: 1;
    text-align: left;
}
@media(min-width: 540px) {
    text-align: left;
}
`;
export default EligibilityCriteria;